import { FILTER_API_BASE_URL } from '../config';

export const bulkFilterAPIRoutes = {
  getBulkValidate: () => `${FILTER_API_BASE_URL}/match-v2`,
};
